import React from 'react';
const RestaurantPricingStrip = () => {
  return <section className="py-16 bg-blue-50" id="pricing" data-id="element-1243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1244">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-1245">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-1246">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-1247">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1248">
                Profitable & Transparent Pricing
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-1249">
                Plans starting from{' '}
                <span className="font-semibold text-blue-600" data-id="element-1250">$349/month</span>{' '}
                with
                <span className="font-semibold text-green-600" data-id="element-1251">
                  {' '}
                  60%+ average profit margins
                </span>{' '}
                on premium beverages
              </p>
              <ul className="space-y-3 mb-8" data-id="element-1252">
                <li className="flex items-start" data-id="element-1253">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1254">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1255"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-1256">
                    Hardware, installation, and IoT monitoring included
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1257">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1258">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1259"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-1260">
                    Syrups and consumables billed only as used
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1261">
                  <svg className="h-5 w-5 text-green-500 mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1262">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1263"></path>
                  </svg>
                  <span className="text-gray-600" data-id="element-1264">
                    Flexible contracts with no hidden fees
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-8 md:p-12 text-white" data-id="element-1265">
              <h3 className="text-2xl font-semibold mb-6" data-id="element-1266">What's included:</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1267">
                <div data-id="element-1268">
                  <h4 className="font-medium text-lg mb-3" data-id="element-1269">Equipment</h4>
                  <ul className="space-y-2" data-id="element-1270">
                    <li className="flex items-center" data-id="element-1271">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1272">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1273"></path>
                      </svg>
                      <span data-id="element-1274">Premium dispensing system</span>
                    </li>
                    <li className="flex items-center" data-id="element-1275">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1276">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1277"></path>
                      </svg>
                      <span data-id="element-1278">IoT inventory monitoring</span>
                    </li>
                    <li className="flex items-center" data-id="element-1279">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1280">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1281"></path>
                      </svg>
                      <span data-id="element-1282">Water filtration system</span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-1283">
                  <h4 className="font-medium text-lg mb-3" data-id="element-1284">Services</h4>
                  <ul className="space-y-2" data-id="element-1285">
                    <li className="flex items-center" data-id="element-1286">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1287">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1288"></path>
                      </svg>
                      <span data-id="element-1289">Professional installation</span>
                    </li>
                    <li className="flex items-center" data-id="element-1290">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1291">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1292"></path>
                      </svg>
                      <span data-id="element-1293">Staff training included</span>
                    </li>
                    <li className="flex items-center" data-id="element-1294">
                      <svg className="h-5 w-5 text-blue-200 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1295">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1296"></path>
                      </svg>
                      <span data-id="element-1297">24/7 technical support</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default RestaurantPricingStrip;